import { combineAfterChanges } from "lib/store";

export const afterChanges = combineAfterChanges([]);
